import type {IAttributes, IAugmentedJQuery, IParseService, IScope} from 'angular';

/**
 * @ngdoc directive
 * @name kpSubmitByEnter
 * @module portaro.directives
 *
 * @param {boolean} kpSubmitByEnter Enable / disable; Default is enabled;
 *
 * @description
 * Because ngForm is not as native form, so it cannot be submitted by pressing `Enter` key. This directive supply this behaviour doing it manually.
 * If directive register `Enter`, it fires submit event.
 *
 * @example
 * ```
 * <example name="kpSubmitByEnterExample" module="kpSubmitByEnterExample" frame-no-resize="true">
 *     <file name="index.html">
 *         <main ng-controller="kpSubmitByEnterExampleController as $ctrl" ng-init="enabled = true">
 *          <div>
 *              <label>Not working</label>
 *              <div>
 *                  <ng-form ng-submit="$ctrl.submit()">
 *                      <input type="text">
 *                  </ng-form>
 *              </div>
 *          </div>
 *
 *          <div>
 *              <label>Working - input with directive</label>
 *              <div>
 *                  <label>Enable submit: <input type="checkbox" ng-model="enabled"></label>
 *              </div>
 *              <ng-form ng-submit="$ctrl.submit()">
 *                  <input type="text" kp-submit-by-enter="{{enabled}}">
 *              </ng-form>
 *          </div>
 *         </main>
 *     </file>
 *     <file name="script.js">
 *         angular.module('kpSubmitByEnterExample', ['portaro.directives'])
 *          .controller('kpSubmitByEnterExampleController', class {
 *              submit() {
 *                  alert('Form has been submitted');
 *              }
 *          });
 *     </file>
 * </example>
 * ```
 */
export default class KpSubmitByEnterDirective {
    public static directiveName = 'kpSubmitByEnter';

    public restrict = 'A';

    /*@ngInject*/
    constructor(private $parse: IParseService) {
    }

    public link($scope: IScope, $element: IAugmentedJQuery, $attrs: IAttributes) {
        const element = $element[0];

        const onKeypressListener = (event: KeyboardEvent) => {
            if ((event.which || event.keyCode) === 13) {

                const isEnabled = this.$parse($attrs[KpSubmitByEnterDirective.directiveName])($scope);
                if (isEnabled === undefined || isEnabled) {

                    const submitEvent = document.createEvent('Event');
                    submitEvent.initEvent('submit', true, true);
                    element.dispatchEvent(submitEvent);
                }
            }
        };

        element.addEventListener('keypress', onKeypressListener);

        $scope.$on('$destroy', () => {
            element.removeEventListener('keypress', onKeypressListener);
        });
    }
}
